import React from "react";
import { FaUser, FaBoxes, FaTags } from "react-icons/fa";
import NewAds from "../../assets/data/NewAds.js";
import User from "../../assets/data/user.js";
import categories from "../../assets/data/category";

function Counts() {
  return (
    <div className="flex flex-wrap justify-start mb-10 lg:gap-6 md:gap-6 gap-4">
      {/* Ads/Product Count */}
      <div className="bg-white rounded-xl shadow-md p-4 lg:w-[200px] md:w-[200px] w-[170px] h-24 flex items-center justify-between">
        <FaBoxes className="text-3xl text-blue-500" />
        <div className="text-right">
          <p className="text-md font-medium">Total Ads</p>
          <h2 className="text-2xl font-semibold text-center">
            {NewAds.length}
          </h2>
        </div>
      </div>

      {/* User Count */}
      <div className="bg-white rounded-xl shadow-md p-4 lg:w-[200px] md:w-[200px] w-[170px] h-24 flex items-center justify-between">
        <FaUser className="text-3xl text-green-500" />
        <div className="text-right">
          <p className="text-md font-medium">Users</p>
          <h2 className="text-2xl font-semibold text-center">{User.length}</h2>
        </div>
      </div>

      {/* Category Count */}
      <div className="bg-white rounded-xl shadow-md p-4 lg:w-[200px] md:w-[200px] w-[170px] h-24 flex items-center justify-between">
        <FaTags className="text-3xl text-red-500" />
        <div className="text-right">
          <p className="text-md font-medium">Categories</p>
          <h2 className="text-2xl font-semibold text-center">
            {categories.length}
          </h2>
        </div>
      </div>
    </div>
  );
}

export default Counts;
